<template>
    <v-row justify=center class="mt-4">
        <v-col cols=9>
            <user-creation-header step=1 title="Vos coordonnées" :alreadyClient="true"/>
            <!-- Modif Ed-Claude 2026-07-17 -->
            <v-alert
                color="secondary"
                variant="tonal"
                density="compact"
                class="already-client-alert text-start text-black mt-8 mb-2"
            >
                <span class="font-weight-bold">Déjà client ?</span>
                <router-link to="/login" class="login-link font-weight-bold text-decoration-underline ml-1">Connectez-vous</router-link>
            </v-alert>
            <div class="text-start text-primary font-weight-bold text-h6 mt-3 mb-4">Coordonnées du responsable</div>
            <user-creation-form class="mb-6"/>
        </v-col>
    </v-row>
</template>

<script>

import UserCreationHeader from '@/components/layout/HeaderBase.vue';
import UserCreationForm from '@/components/user-creation/UserCreationForm.vue';

export default {
    components: {
        UserCreationHeader,
        UserCreationForm
    },
};

</script>

<style scoped>

/* Modif Ed-Claude 2026-07-17 — hauteur alignée sur les champs compacts */
.already-client-alert {
    border: 1px solid rgba(169, 52, 63, 0.28);
    border-radius: 8px;
    min-height: 0 !important;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
    padding-inline: 14px !important;
}

.already-client-alert :deep(.v-alert__content) {
    color: #000 !important;
    font-size: 14px;
    line-height: 1.35;
    padding: 0 !important;
}

.already-client-alert :deep(.v-alert__underlay),
.already-client-alert :deep(.v-alert__prepend),
.already-client-alert :deep(.v-alert__append) {
    display: none;
}

.login-link {
    font-size: 14px;
    color: #a9343f;
}

.subtitle-contact {
    font-weight: 400 !important;
}

</style>
